import { FC, useEffect } from 'react'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import useMap from 'hooks/useMap'
import Button from 'components/Button'
import IconQuestionMark from 'icons/IconQuestionMark'
import { clickFAQButtonEvent } from '../../events'
import { TType } from '../../types'
import styles from '../../styles.module.scss'

const FAQModal = dynamic(
  () => import('pages/perfil/minhas-indicacoes/components/FAQ/Modal'),
)

export type TProps = {
  type: TType
  onButtonClick?: () => void
  onModalClose?: () => void
  onAccordionOpen?: (title: string) => void
}

const FAQ: FC<TProps> = ({
  type,
  onButtonClick,
  onModalClose,
  onAccordionOpen,
}) => {
  const router = useRouter()
  const openFaq = router.asPath?.includes('faq')
  const [modalMap, { setAll: setAllFaqModal }] = useMap({
    isMounted: openFaq,
    isVisible: openFaq,
  })

  const setModal = (open: boolean, changeRouterHash = true) => {
    setAllFaqModal({
      isMounted: modalMap.isMounted || open,
      isVisible: open,
    })
    if (changeRouterHash) {
      if (open) {
        void router.push({ hash: 'faq' }, undefined, {
          scroll: false,
        })
      } else {
        void router.replace({ hash: '#' }, undefined, { scroll: false })
      }
    }
  }

  useEffect(() => {
    setModal(openFaq, false)
  }, [openFaq])

  return (
    <>
      {modalMap.isMounted && (
        <FAQModal
          type={type}
          visible={modalMap.isVisible}
          handleBackgroundClick={() => {
            setModal(false)
            if (onModalClose) onModalClose()
          }}
          handleCloseButtonClick={() => {
            setModal(false)
            if (onModalClose) onModalClose()
          }}
          handleAccordionClick={(title) => {
            if (onAccordionOpen) onAccordionOpen(title)
          }}
        />
      )}

      <Button
        className={styles.ecFaqButton}
        shape="circle"
        Icon={{
          Component: IconQuestionMark,
          title: 'Dúvidas',
          color: 'grey900',
        }}
        aria-label="Ajuda"
        onClick={() => {
          if (onButtonClick) onButtonClick()
          clickFAQButtonEvent()
          setModal(true)
        }}
      />
    </>
  )
}

export default FAQ
